export default "__VITE_ASSET__19da9091__"